<template>
  <v-container fluid class="products-on-offer-table">
    <v-row v-if="!isJaneModulePermission">
      <v-col cols="23">
        <h4>
          O uso de grupos nessa tela não altera o funcionamento padrão dos mesmos. Cada SKU ainda é considerado de forma única e unitária na aplicação da
          oferta. O consumidor deve ter no cupom a quantidade mínima de um mesmo SKU para ter acesso ao produto com desconto.
        </h4>
      </v-col>
    </v-row>
    <div class="d-flex align-center justify-end" :class="{ 'py-3': isJaneModulePermission }" style="gap: 20px">
      <tooltip :disabled="isTooltipNewComboDisabled" :message="tooltipMessage">
        <mf-button
          v-if="!isCampaignWithOfferSale"
          class="elevation-0"
          :disabled="isNewComboDisabled || disabled"
          label="Novo Combo"
          @click="addNewCombo"
        ></mf-button>
      </tooltip>
      <mf-search v-model="search" class="custom-search" dense hide-details placeholder="Busque um combo" autofocus @input="filterProducts" />
    </div>
    <v-row>
      <v-col class="px-0" cols="12">
        <v-expansion-panels v-if="filteredProducts.length" v-model="panel" multiple>
          <v-expansion-panel v-for="(offerCombo, index) in filteredProducts" :key="index" class="expansion-panel">
            <v-expansion-panel-header class="expansion-header">
              <v-img v-if="offerCombo.image" :src="offerCombo.image" class="expansion-header-img" contain />
              <div v-else class="expansion-header-img d-flex align-center justify-center">
                <mf-icon> image_not_supported </mf-icon>
              </div>
              <span class="expansion-header-title">{{ offerCombo.name.length ? offerCombo.name : 'Combo sem nome' }}</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <products-on-offer-combo-cards
                :campaign="campaign"
                :discount-description-text="discountDescriptionText"
                :trigger-description-text="triggerDescriptionText"
                :offer-combo="offerCombo"
                :id-key="index"
                :offer-sales-key-name="offerSalesKeyName"
                :second-offer-sales-key-name="secondOfferSalesKeyName"
                :eans="eans"
                :segments="segments"
                :automatic-campaign="automaticCampaign"
                :repeated-skus="repeatedSkus"
                :status-campaign="statusCampaign"
                :update-eans="updateEans"
                :card-validation="$v.offerComboArray.$each.$iter[index]"
                :validations="$v"
                :is-disabled-in-rules="isDisabledInRules"
                :tooltip-message="tooltipMessage"
                :disabled-fields="disabled"
                :is-campaign-with-offer-sale="isCampaignWithOfferSale"
                @removeItem="removeCombo"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-card v-else height="50px">
          <v-row class="py-5" justify="center">
            <p class="mb-0 texto-corrido">Não há dados</p>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ProductsOnOfferComboCards from '../offer-combo/ProductsOnOfferComboCards.vue'
import cloneDeep from 'lodash/cloneDeep'
import { v4 as uuidv4 } from 'uuid'
import { statusCampaignValidator } from '@/helpers/propValidators.js'
import { required, minLength, requiredIf, minValue, maxValue, numeric, integer } from 'vuelidate/lib/validators'
import { notOnlySpace } from '@/helpers/validators.js'
import { eansValidation, distributionLimitValidation } from '../../../helpers/validators'
import { rules } from '../../../helpers/rules.js'
import Tooltip from '../Tooltip.vue'
import intelligentDistributionMixin from '../../mixins/intelligent-distribution'

export default {
  name: 'ProductsOnOfferCombo',
  components: {
    ProductsOnOfferComboCards: ProductsOnOfferComboCards,
    Tooltip,
  },
  mixins: [intelligentDistributionMixin],
  props: {
    campaign: {
      type: Object,
      default: () => ({}),
    },
    automaticCampaign: {
      type: Boolean,
      default: false,
    },
    products: {
      type: Array,
      default: () => [],
    },
    disabledFunction: {
      type: Boolean,
      default: false,
    },
    offerSalesKeyName: {
      type: String,
      required: true,
    },
    secondOfferSalesKeyName: {
      type: String,
      required: true,
    },
    eans: {
      type: Object,
      required: true,
    },
    segments: {
      type: Array,
      required: true,
    },
    repeatedSkus: {
      type: Array,
      default: () => [],
    },
    statusCampaign: {
      type: String,
      validator: statusCampaignValidator,
    },
    isDisabledInRules: {
      type: Function,
      default: () => false,
    },
    tooltipMessage: {
      type: String,
      default: '',
    },
    isIndustryCampaign: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isCampaignWithOfferSale: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    search: '',
    defaultNewCombo: {
      name: '',
      maximum_per_client: 0,
      image: '',
      combo_id: '',
      trigger_products: [],
      target_products: [],
      active: true,
    },
    productsLocal: [],
    panel: [],
    rules,
  }),
  computed: {
    offerComboArray: {
      get() {
        return this.products
      },
      set(value) {
        this.$emit('update:products', value)
      },
    },
    isJaneModulePermission() {
      return this.$getAllowedModules()['jane']
    },
    filteredProducts() {
      return this.search !== '' ? this.productsLocal : this.offerComboArray
    },
    discountDescriptionText() {
      if (this.isCampaignWithOfferSale) return 'Produto que consumidor receberá quando os critérios.'
      return this.isJaneModulePermission
        ? `Quando os critérios para ativar o desconto forem atingidos, o consumidor vai ter acesso a APENAS UM dos produtos dentro de um grupo e TODOS os produtos soltos. Se o consumidor atingir os critérios do combo ele pode levar apenas alguns dos descontos dentro dessa sessão.`
        : `Produto que receberá o desconto do combo. Apenas um produto pode ser alvo do desconto, para ter mais produtos é preciso criar outro combo.`
    },
    triggerDescriptionText() {
      if (this.isCampaignWithOfferSale) return 'Produtos e suas quantidades que o consumidor deve ter na cesta para ter acesso ao produto adicionado ao lado.'
      return this.isJaneModulePermission
        ? 'Cadastre aqui os produtos que ativam os descontos cadastrados ao lado. Um grupo aqui permite que o consumidor consiga comprar qualquer combinação de EANs dentro desse grupo para atingir a quantidade indicada no combo.'
        : 'Produtos e suas quantidades que o consumidor deve ter na cesta para ter acesso ao desconto no produto adicionado ao lado.'
    },

    isTooltipNewComboDisabled() {
      return this.isIndustryCampaign ? !this.isNewComboDisabled : true
    },

    isNewComboDisabled() {
      return (
        (this.segments && this.segments.length > 0 && this.statusCampaign === 'active') ||
        this.automaticCampaign ||
        this.isDisabledInRules(this.rules.comboOfferSales.newCombo)
      )
    },
  },
  methods: {
    addNewCombo() {
      const newIndexPanel = this.offerComboArray.length

      this.panel.push(newIndexPanel)
      this.defaultNewCombo.combo_id = uuidv4()
      this.offerComboArray.push(cloneDeep(this.defaultNewCombo))

      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight)
      }, 500)
    },
    removeCombo(index) {
      this.$confirm({
        title: 'Apagar combo',
        message: `Clicando em confirmar você vai apagar esse combo
          e todas as suas configurações. Essa ação não pode ser desfeita.`,
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        cancelColor: 'error',
      }).then(() => {
        this.offerComboArray.splice(index, 1)
        this.panel.splice(index, 1)
      })
    },
    updateEans(eansProduct, group, keyName) {
      const propertyName = keyName === 'combo_offer_sales' ? 'trigger_products' : 'target_products'
      this.$emit('update-eans', eansProduct, group, this.offerSalesKeyName, propertyName)
    },
    checkValidations() {
      this.$v.$touch()
      if (this.$v.$error || this.$v.$invalid) {
        this.$snackbar({ message: 'Preencha todos os campos corretamente', snackbarColor: 'error' })
        Object.keys(this.$v.offerComboArray.$each.$iter).forEach((item, index) => {
          const validations = this.$v.offerComboArray.$each.$iter
          if ((validations[item].$error || validations[item].$invalid) && !this.panel.includes(index)) {
            this.panel.push(index)
          }
        })
        return false
      }
      return true
    },
    filterProducts(searchKey) {
      let arrayOfMatchedObjects = this.offerComboArray.filter((object) => {
        return JSON.stringify(object).toString().toLowerCase().includes(searchKey.toLowerCase())
      })
      this.productsLocal = searchKey !== '' ? arrayOfMatchedObjects : []
    },
  },
  validations() {
    return {
      offerComboArray: {
        $each: {
          name: { required, notOnlySpace, minLength: minLength(3) },
          maximum_per_client: { required, minValue: minValue(1) },
          distribution_limit: { distributionLimitValidation: distributionLimitValidation(this) },
          trigger_products: {
            required,
            $each: {
              sku: requiredIf(function (group) {
                return !group.products
              }),
              name: { required, notOnlySpace },
              quantity: { minValue: minValue(1), integer, maxValue: maxValue(999), required },
              eans: {
                eansValidation,
              },
              products: {
                $each: {
                  eans: {
                    eansValidation,
                  },
                  name: { required, notOnlySpace },
                },
              },
            },
          },
          target_products: {
            required,
            $each: {
              sku: requiredIf(function (group) {
                return !group.products
              }),
              name: { required, notOnlySpace },
              percentage_discount: { minValue: minValue(1), maxValue: maxValue(100), numeric, required },
              eans: {
                eansValidation,
              },
              products: {
                $each: {
                  eans: {
                    eansValidation,
                  },
                  name: { required, notOnlySpace },
                },
              },
            },
          },
        },
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.products-on-offer-table {
  .products-on-offer-table__expand-label {
    display: block;
    cursor: pointer;
  }
  ::v-deep.v-expansion-panel {
    padding: 12px 24px;
    &--active {
      padding: 12px 24px 24px;
    }
    &-content__wrap {
      padding: 0;
    }
    &-header {
      &--active {
        border-bottom: 1px solid $cinza-l80;
      }
    }
  }
  .expansion-header {
    display: flex;
    column-gap: 16px;
    padding: 0;
    &-img {
      max-width: 40px;
      height: 40px;
    }
    &-title {
      font-family: 'Lato';
      font-weight: 400;
      font-size: 18px;
      color: $cinza-d10;
    }
  }
  .row-width {
    width: 300px;
  }

  .custom-search {
    max-width: 275px;
  }
}
</style>
